import { useCallback, useEffect, useState } from 'react';

/**
 * A hook that handles slide change events in an Embla carousel
 * @param {Object} emblaApi - The embla API object
 * @param {Function} handleSlideChange - Callback function called when the slide changes with { slideNumber }
 * @returns {Object} Object containing the selectedIndex
 */
function useOnSlideChange(emblaApi, handleSlideChange) {
    const [selectedIndex, setSelectedIndex] = useState(0);

    const onSelect = useCallback(() => {
        const slideNumber = emblaApi.selectedScrollSnap();
        setSelectedIndex(slideNumber);
        if (typeof handleSlideChange === 'function') {
            handleSlideChange(slideNumber);
        }
    }, [emblaApi, handleSlideChange]);

    useEffect(() => {
        if (!emblaApi) {
            return undefined;
        }

        setSelectedIndex(emblaApi.selectedScrollSnap());

        emblaApi.on('select', onSelect);

        return () => {
            emblaApi.off('select', onSelect);
        };
    }, [emblaApi, onSelect]);

    return {
        selectedIndex,
    };
}

export default useOnSlideChange;
